import { Moment } from "moment";
import { ContactDetails } from "../CommonProps";
import { LoanAssign } from "../modals/LoanAssign";
import { LoanCar } from "../modals/LoanCar";
import { LoanCarBooking } from "../modals/LoanCarBooking";
import IBSService from "./IBSService";
import { JobEstimationDetail } from "../modals/JobEstimationDetail";

const ibsService = new IBSService();

export const getAvailableLockBoxes = async (
  day: Moment
): Promise<LoanCar[]> => {
  const lockBoxes: LoanCar[] = (
    await (await ibsService.getLoanCars()).json()
  ).filter(
    (x: LoanCar) => x.classification === "Lock Box" && x.inactive === false
  );

  const lockBoxAssigns: LoanAssign[] = await (
    await ibsService.getLoanCarsBookings(
      day.format("YYYY-MM-DDTHH:ss"),
      day.format("YYYY-MM-DDTHH:ss")
    )
  ).json();

  const availableLockBoxes = lockBoxes.filter((x) => {
    if (lockBoxAssigns.find((a) => a.loanCarId === x.id)) {
      return false;
    } else {
      return x;
    }
  });

  return availableLockBoxes;
};

export const bookLoanCar = async (
  date: Moment,
  estimateDetails: JobEstimationDetail,
  loanCar: LoanCar
) => {
  const contactDetails: ContactDetails = {
    mobilePhone: estimateDetails.mobilePhone,
    emailAddress: estimateDetails.email,
    firstName: estimateDetails.firstName,
    lastName: estimateDetails.lastName,
    displayName: estimateDetails.ownerName
  };
  const body: LoanCarBooking = {
    contact: contactDetails,
    dateFrom: date.format("YYYY-MM-DDT00:00"),
    dateTo: date.format("YYYY-MM-DDT23:59"),
    driver: {
      contactDetails: {}
    },
    estimateId: estimateDetails.estimateId,
    estimateNumber: estimateDetails.estimateNumber.toString(),
    loanCarId: loanCar.id
  };

  return await ibsService.createLoanCarBookings(body);
};
